// extracted by mini-css-extract-plugin
export default {"localizedText":"src-components-elements-localizedText-styleslocalizedText"};